import { CircularProgress, styled } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

export const LoadingButtonContainer = styled("div")`
  display: inline-block;
  position: relative;
  line-height: 0;

  &.full-width {
    width: 100%;
  }
`;

export const LoadingButtonSpinnerContainer = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const LoadingButtonSpinner = styled(withDefaultProps(CircularProgress, { size: 24 }))`
  flex: 0 0 auto;
  line-height: 0;
`;
